import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { User, Mail, Phone, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { useCustomerAuth } from '../context/CustomerAuthContext';

// Inline login / register form. Calls onSuccess(customer) after authenticating.
const InlineAuth = ({ onSuccess, actionLabel }) => {
  const { login, register } = useCustomerAuth();
  const [mode, setMode] = useState('login');
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      let customer;
      if (mode === 'register') {
        if (!form.name || !form.email || !form.phone || !form.password) {
          toast.error('Please fill in all fields');
          setSubmitting(false);
          return;
        }
        customer = await register(form);
        toast.success('Account created!');
      } else {
        customer = await login(form.email, form.password);
        toast.success('Logged in!');
      }
      if (onSuccess) onSuccess(customer);
    } catch (err) {
      toast.error(err.message || 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="inline-auth">
      <form onSubmit={submit} className="space-y-3">
        {mode === 'register' && (
          <div className="relative">
            <User className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
            <Input data-testid="inline-auth-name" className="pl-9" value={form.name} onChange={(e) => setField('name', e.target.value)} placeholder="Full name" />
          </div>
        )}
        <div className="relative">
          <Mail className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
          <Input data-testid="inline-auth-email" type="email" className="pl-9" value={form.email} onChange={(e) => setField('email', e.target.value)} placeholder="Email" />
        </div>
        {mode === 'register' && (
          <div className="relative">
            <Phone className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
            <Input data-testid="inline-auth-phone" className="pl-9" value={form.phone} onChange={(e) => setField('phone', e.target.value)} placeholder="Phone number" />
          </div>
        )}
        <div className="relative">
          <Lock className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
          <Input data-testid="inline-auth-password" type="password" className="pl-9" value={form.password} onChange={(e) => setField('password', e.target.value)} placeholder="Password" />
        </div>
        <Button type="submit" disabled={submitting} data-testid="inline-auth-submit" className="w-full bg-amber-600 hover:bg-amber-700 text-white">
          {submitting ? 'Please wait...' : actionLabel ? actionLabel : (mode === 'login' ? 'Log In & Send Inquiry' : 'Create Account & Send Inquiry')}
        </Button>
      </form>
      <div className="text-center mt-3">
        <button
          type="button"
          data-testid="inline-auth-toggle"
          onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
          className="text-amber-600 hover:text-amber-700 font-medium text-sm"
        >
          {mode === 'login' ? "New here? Create an account" : 'Already have an account? Log in'}
        </button>
      </div>
    </div>
  );
};

export default InlineAuth;
